/**
 * 判断是否是小程序
 * @returns
 */
export const isInMiniProgram = () => {
  const ua = navigator.userAgent
  return /miniprogram/i.test(ua) // 小程序环境中，userAgent通常包含miniprogram关键字
}